/**
 * Author: Ivan Horobets
 * Email: i@altsolution.net
 * Company: AltSolution
 */

"use strict";

import FilterProducts from "./helpers/filter/FilterProductsClass";

jQuery.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

import Utils from './helpers/UtilsClass';
import HeaderActions from './helpers/HeaderActionsClass';
import AuthFormsSubmit from './helpers/AuthFormsSubmitClass';
import Catalog from './helpers/CatalogClass';
import SingleProduct from './helpers/SingleProductClass';

import Cart from './helpers/CartClass';
import Chackout from './helpers/CheckoutClass';
import CartActions from './helpers/product/CartActionsClass';

import FavoriteActions from "./helpers/product/FavoriteActionsClass";
import CompareActions from "./helpers/product/CompareActionsClass";
import AwaytActions from "./helpers/product/AwaytActionsClass";

import Compare from './helpers/CompareClass';
import Contacts from './helpers/ContactsClass';
import About from './helpers/AboutClass';

import Profile from './helpers/profile/ProfileClass';
import ProfileChangePhone from './helpers/profile/ChangePhoneClass';
import ProfileOrders from "./helpers/profile/OrdersClass";
import ProfileService from "./helpers/profile/ServiceClass";
import ProfileSubscription from "./helpers/profile/SubscriptionClass";

import FilterSearch from "./helpers/filter/FilterSearchClass";

/**
 * Classes initial
 */
Utils.initial();
new HeaderActions().initial();
new CartActions().getCart();
new FavoriteActions().getFavorites();
new CompareActions().getCompare();
new AuthFormsSubmit();
new AwaytActions();

//Search
if ('searchObj' in window) {
    const argFilter = {
        container: '.catalog_wrap',
        filterUrl: filterRoute.url,
        fastFiltersCl: '.big_sorting--sorting li[data-f], .catalog_mob_filter .select_content li[data-f]',
        rangeFiltersCl: '.value_ranges button[type="button"]',
        optionsFiltersCl: '#special_option input',
        categoryFiltersCl: '#special_category input',
        filtersCl: '.catalog_filter .filter_block:not(#special_option) :checkbox',
        changeViewCl: '.big_sorting--structure li',
        params: filterParams
    };
    new FilterSearch(argFilter);
}
//FilterSearch

//Catalog
if ('categoryObj' in window || 'searchObj' in window) {
    Catalog.initial();
}

//Single product
if ('singleProductObj' in window) {
    SingleProduct.initial();
}

//Cart pages
if ('cartObj' in window) {
    Cart.initial();
}

//Checkout pages
if ('checkoutObj' in window) {
    new Chackout();
}

//Compare page
if('compareObj' in window) {
    Compare.initial();
}

//Contacts page
if('contactsObj' in window) {
    Contacts.initial();
}

//About page
if('aboutObj' in window) {
    About.initial();
}

//Profile pages
if('profileObj' in window) {
    new Profile();
    new ProfileChangePhone();
    new ProfileOrders();
    new ProfileService();
    new ProfileSubscription();
}

/**
 * Check on empty input
 */
let $formStyle = $('.form_style');
$formStyle.on('blur', 'input, textarea', function () {
    if($(this).val().length > 0) {
        $(this).addClass('full');
    } else {
        $(this).removeClass('full');
    }
});


/**
 * Scrollbar
 */
if($(window).width() >= 1200) {
    $('.scrollbar-inner').scrollbar();
}


/**
 * Form validate
 */
$.validator.methods.email = function( value, element ) {
    return this.optional( element ) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z-])+\.)+([a-zA-Z]{2,4})+$/.test( value );
};
$.validator.methods.tel = function( value, element ) {
    return this.optional( element ) || /^((\+38)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test( value );
};

/**
 * Hide|Show password
 */
let $fPass = $('.form-group input[type="password"]');
if($fPass.length) {
    $fPass.parent().on('click', '.icon-visibility_off, .icon-visibility', function () {
        if($(this).hasClass('icon-visibility_off')) {
            $(this).siblings('input').attr('type', 'text');
            $(this).removeClass('icon-visibility_off');
            $(this).addClass('icon-visibility');
        } else {
            $(this).siblings('input').attr('type', 'password');
            $(this).removeClass('icon-visibility');
            $(this).addClass('icon-visibility_off');
        }
    });
}

/**
 * Show/Hide Seo
 */
var $seoWrap = $('.seo_section');
if($seoWrap.length) {
    var $seoTrigger = $('#seo-control');

    if($seoWrap.outerHeight() > 150) {
        $seoWrap.css('max-height', '150px');

        $seoTrigger.find('a').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $seoWrap.toggleClass('open');

            if($(this).hasClass('open')) {
                $seoWrap.removeAttr('style');
            } else {
                $seoWrap.css('max-height', '150px');
            }
        });
    } else {
        $seoWrap.addClass('full');
        $seoTrigger.remove();
    }
}

/**
 * Products carousels
 */
let $productCarousels = $('.products_carousel');
if($productCarousels.length) {
    const DEF_RESP = {
        0:{
            items:1,
            margin: 0,
            slideBy: 1,
            nav: false,
            autoWidth: true,
        },
        768:{
            items:3,
            margin: 0,
            slideBy: 3,
            nav: false,
        },
        992:{
            items:4,
            margin: 0,
            slideBy: 4,
            nav: false,
        },
        1200:{
            items:4,
            margin: 0,
            dots: false,
            slideBy: 4,
            nav: true,
        }
    };
    $productCarousels.each(function (index) {
        $(this).owlCarousel({
            loop: false,
            margin: 0,
            dots: true,
            navText: ['<i class="icon icon-arrow_prew"></i>', '<i class="icon icon-arrow_next"></i>'],
            responsive: $(this).attr('data-responsive') ? JSON.parse($(this).attr('data-responsive')) : DEF_RESP
        });
    });

    //console.log(window.initProductCarousel);
}

/**
 * Main slider
 */
let $mainSlider = $('#main_slider');
if($mainSlider.length) {

    // $mainSlider.on('initialized.owl.carousel', function (event) {
    //     console.log(event.item.count);
    //     $mainSlider.addClass('single');
    // });

    $mainSlider.owlCarousel({
        loop: true,
        margin: 0,
        dots: true,
        nav: true,
        autoplay: ($mainSlider.attr('data-autoplay') && $mainSlider.attr('data-autoplay') != '0') ? true : false,
        autoplayTimeout: $mainSlider.attr('data-pause'),
        autoplaySpeed: $mainSlider.attr('data-speed'),
        autoplayHoverPause: ($mainSlider.attr('data-autoplay') && $mainSlider.attr('data-autoplay') != '0') ? true : false,
        navText: ['<i class="icon icon-arrow_prew"></i>', '<i class="icon icon-arrow_next"></i>'],
        responsive:{
            0:{
                items:1,
                margin: 0
            }
        }
    });
}

/**
 * Get more data for popups
 */
$(document).on('click', '.fade-popup', function () {
    if($(this).attr('data-insert')) {
        window.popupMoreInfo = JSON.parse($(this).attr('data-insert'));
    } else {
        window.popupMoreInfo = null;
    }
});

/**
 * Go to auth if not aunt
 */
$(document).on('click', '.to_auth_window', function (e) {
    e.preventDefault();
    if($(window).width() >= 1200) {
        $('html, body').stop().animate({
            'scrollTop': 0
        }, 500);
        $('a[data-click-id="#login_desktop"]').trigger('click');
    } else {
        $('a[data-swipe="#login_slide"]').trigger('click');
    }
});


/**
 * Popups Fade In send forms
 * And other small forms where need just send form
 */
let $popupsFadeIn = $('.wrap_fade_popup, .contact_form');
if($popupsFadeIn.length) {
    $popupsFadeIn.find('form:not(.no-small)').each(function () {
        let $this = $(this),
            $thisF = $(this).validate({
            highlight: function (element) {
                $(element).parent().addClass("error").removeClass("valid");
            },
            unhighlight: function (element) {
                $(element).parent().removeClass("error").addClass("valid");
            },
            submitHandler: function (form) {

                //Check actions
                let action = $(form).attr('action'),
                    formData = new FormData($(form)[0]);

                //Add more data if not exist
                if(window.popupMoreInfo && window.popupMoreInfo !== null) {
                    for (let property in window.popupMoreInfo) {
                        formData.append(property, window.popupMoreInfo[property]);
                    }
                }

                $(form).find('button[type="submit"]').prop('disabled', true);
                $.ajax({
                    type: "POST",
                    url: action,
                    processData: false,
                    contentType: false,
                    data: formData
                }).done(function (res) {

                    if(res.success) {
                        $(form).fadeOut(200, function () {
                            $(form).siblings('.thanks').fadeIn(200);
                            $(form).find('button[type="submit"]').prop('disabled', false);

                            //Clear
                            $(form)[0].reset();
                            $thisF.resetForm();
                            $(form).find('.full:not([name="date_from"]):not([name="date_to"])').each(function () {
                                if($(this).val() === '') {
                                    $(this).removeClass('full');
                                }
                            });
                            window.popupMoreInfo = null;

                            $(form).find('.drop_down-list li').removeClass('active');
                        });
                        return true;
                    }
                    alert('Упс.');
                });
            }
        });

        //Reset form after close
        //TODO: many request
        $(document).bind('fade.reset.form.popup', function () {
            $this[0].reset();
            $thisF.resetForm();
        });
    });
}

/**
 * Fast order
 */
let $formFastOrder = $('.fast-order-form');
if($formFastOrder.length) {
    $formFastOrder.each(function () {
        let $thisInit = $(this).validate({
            highlight: function (element) {
                $(element).parent().addClass("error").removeClass("valid");
            },
            unhighlight: function (element) {
                $(element).parent().removeClass("error").addClass("valid");
            },
            submitHandler: function (form) {

                //Check actions
                let action = $(form).attr('action'),
                    formData = new FormData($(form)[0]);

                //Add more data if not exist
                if(window.popupMoreInfo && window.popupMoreInfo !== null) {
                    for (let property in window.popupMoreInfo) {
                        formData.append(property, window.popupMoreInfo[property]);
                    }
                }

                $(form).find('button[type="submit"]').prop('disabled', true);

                $.ajax({
                    type: "POST",
                    url: action,
                    processData: false,
                    contentType: false,
                    data: formData
                }).done(function (res) {
                    if(res.success) {
                        window.location.href = res.data.redirect;
                        return true;
                    }
                    alert('Упс.');
                });
            }
        });
    })
}


/**
 * Test drive form
 * @deprecated ?
 */
let $testDriveBl = $('#test-drive-block');
if($testDriveBl.length) {
    $testDriveBl.validate({
        highlight: function (element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function (element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function (form) {
            //Check actions
            let action = $(form).attr('action');

            $(form).find('button[type="submit"]').prop('disabled', true);
            setTimeout(function () {
                $(form).find('.form_input').animate({opacity: 0}, function () {
                    $(form).find('.thanx').fadeIn(200);
                });
            }, 1000);

            // let formData = new FormData($(form)[0]);
            // $.ajax({
            //     type: "POST",
            //     url: action,
            //     processData: false,
            //     contentType: false,
            //     data: formData
            // }).done(function (data) {
            //     //TODO: create some actions after programing
            // });
        }
    });

}


/**
 * Fix for sliders on IOS
 * TODO: try find more better solutions
 */
let options = {
    preventDefault: true
};
$('.owl-carousel').each(function () {
    let hammertime = new Hammer($(this)[0], options);
    hammertime.on("swipeleft swiperight", function(ev){});
});


/**
 * Edge replace images.
 * Because some Edge browser is stupid!
 */
if (/Edge/.test(navigator.userAgent)) {
    $('picture').each(function () {
        $(this).after(($(this).find('img')));
        $(this).remove();
    });
}

/**
 * Replace webp style if webp not supported
 */
if($('html').hasClass('no-webp')) {
    $('.webp-gb-style').each(function () {
        let imgUrl = $(this).attr('data-img');
        $(this).removeAttr('style');
        $(this).css({
            'background': 'url('+ imgUrl +') center no-repeat',
            'background-size': 'cover'
        });
    });
}

/**
 * DotDotDot for all products items
 */
$(".dotdotdot").dotdotdot({
    height: 60,
    watch: 'window'
});


let delayInfoTimer = null;
$('body').on('mouseenter touchstart', '.icon-info', function() {
    clearTimeout(delayInfoTimer);
    $('.icon-info').siblings('p').hide();

    var infoBlock = $(this).siblings('p');
    if(($(this).offset().left + 165) > $(window).width()) {
        infoBlock.css({
            left: 'auto',
            right : '14px',
            display : 'block'
        });
    } else {
        infoBlock.css({
            right: 'auto',
            left : '14px',
            display : 'block'
        });
    }
})
.on('mouseleave ', '.icon-info', function() {
    delayInfoTimer = null;
    clearTimeout(delayInfoTimer);
    var $this = $(this);
    delayInfoTimer = setTimeout(function () {
        $this.siblings('p').hide();
    }, 300)
});
